/** @jsxImportSource @emotion/react */
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import { FieldRenderProps } from 'react-final-form'
import * as classes from './styles'

function SignInSwitch({ input, props }: FieldRenderProps<boolean, HTMLElement>) {
  return (
    <FormControlLabel
      css={classes.switchEl}
      id="rememberMe"
      label="Remember Me"
      control={<Switch />}
      {...input}
      {...props}
    />
  )
}

export default SignInSwitch
